// App.js
import "./index.scss";
import React, { useContext, useEffect, useState } from "react";
import Navbarr from "../../components/Navbarr";
import ProductList from "../../components/ProductList";
import Sidebar from "../../components/SideBar";
import Footerr from "../../components/Footerr";
import { getProducts } from "../../services/get-all-products";
import { toast } from "react-toastify";
import { getCategoriesNum } from "../../services/get-categories-num";
import Carrousel from "../../components/Carrousel/Carrousel";
import Lottie from "react-lottie";
import {
  defaultOptionsEmpty,
  defaultOptionsLoading,
} from "../../assets/lottie-animations/animationOptions";
import { BsTruck, BsChatDots } from "react-icons/bs";
import { FaTags, FaUndo } from "react-icons/fa";

import { getPackages } from "../../services/get-all-packages";
import Auth, { UserContext } from "../../components/context/userContext";
import { Helmet } from "react-helmet-async";

function Acceuil() {
  const [listProducts, setListProducts] = useState<any>([]);
  const [listCategoriesNum, setListCategoriesNum] = useState([]);
  const [listPackages, setListPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPackage, setLoadingPackage] = useState(false);
  const { networkError, setNetworkError } = useContext(UserContext);

  const doGetAllProducts = () => {
    setLoading(true);
    getProducts()
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setListProducts(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const doGetCategoriesNum = () => {
    setLoading(true);
    getCategoriesNum()
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setListCategoriesNum(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  const doGetAllPackages = () => {
    setLoadingPackage(true);
    getPackages()
      .then((response) => {
        setLoadingPackage(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setListPackages(response?.content);
        }
      })
      .catch((error) => {
        setLoadingPackage(false);

        toast.error(error);
      });
  };

  useEffect(() => {
    doGetAllProducts();
    doGetAllPackages();
    doGetCategoriesNum();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Smartphones en Tunisie – iPhone, Samsung, Xiaomi | Mhiri Store
        </title>
        <meta
          name="description"
          content="Achetez votre smartphone en Tunisie au meilleur prix : iPhone, Samsung, Xiaomi avec garantie et livraison rapide partout en Tunisie."
        />
      </Helmet>
      <div className="App-home">
        <Navbarr page={"acceuil"} />
        <h1 style={{ display: "none" }}>
          Smartphones et accessoires en Tunisie – Mhiri Store
        </h1>

        <div className="content-home">
          <Sidebar
            listCategoriesNum={listCategoriesNum}
            setListCategoriesNum={setListCategoriesNum}
          />
          <div className="advantages-bar">
            <div className="advantage-item">
              <BsTruck className="advantage-icon" />
              <div className="advantage-text">
                <strong>LIVRAISON GRATUITE</strong>
                <span>Panier plus que 250 DT</span>
              </div>
            </div>
            <div className="advantage-item">
              <FaTags className="advantage-icon" />
              <div className="advantage-text">
                <strong>Offre Spéciales</strong>
              </div>
            </div>
            <div className="advantage-item">
              <FaUndo className="advantage-icon" />
              <div className="advantage-text">
                <strong>Retour en cas de problème</strong>
              </div>
            </div>
            <div className="advantage-item">
              <BsChatDots className="advantage-icon" />
              <div className="advantage-text">
                <strong>Chat 24/24</strong>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Carrousel />
          </div>
          <div
            style={{
              borderBottomWidth: 2,
              borderTopWidth: 2,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderStyle: "solid",
              borderColor: "#a3a3a3",
              width: "90%",
              marginTop: 5,
              display: "flex",
              alignSelf: "center",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2 style={{ textAlign: "center" }}>Nos Produits</h2>
          </div>
          {!loading ? (
            <ProductList listProducts={listProducts} type={"product"} />
          ) : (
            <div
              style={{
                height: "100%",
                width: "100%",
                paddingTop: 150,
                paddingBottom: 150,
              }}
            >
              <Lottie
                options={defaultOptionsLoading}
                height={150}
                width={150}
              />
            </div>
          )}
          <div>
            <h2 style={{ textAlign: "center" }}>Nos Packages</h2>
          </div>
          {!loadingPackage ? (
            <ProductList listProducts={listPackages} type={"package"} />
          ) : (
            <div
              style={{
                height: "100%",
                width: "100%",
                paddingTop: 150,
                paddingBottom: 150,
              }}
            >
              <Lottie
                options={defaultOptionsLoading}
                height={150}
                width={150}
              />
            </div>
          )}
        </div>
        <Footerr />
      </div>
    </>
  );
}

export default Acceuil;
